import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import TextField from "@mui/material/TextField";
import PNXLabel from "./PNXLabel";


interface Props {
  controlProps: controls.FormControl;
  updateValue: (newValue: string) => void;
  onControlBlur: () => void;
};

const PhoenixTextArea = ({
  controlProps,
  updateValue,
  onControlBlur,
} : Props) => {

  const id = `phoenixtextarea-${controlProps.id}`;

  return <div>
    <PNXLabel controlType="label" htmlFor={id} helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>
    <TextField
      id={id}
      variant="standard"
      multiline
      fullWidth
      onChange={(e) => { updateValue(`${e.target.value}`); }}
      onBlur={() => { onControlBlur(); }}
      value={controlProps.value ?? ""}
      placeholder="Enter Value..."
      minRows={4}
    />
  </div>;
};

export default PhoenixTextArea;